import React from 'react';
import fr from 'facet-rest';
import {
  FDBodyText,
  FDHeadlineText,
  FDStack,
} from '@facet-wealth/design';
import { Stepper } from 'Components/UI/guidedHouseholdReview/stepper';
import { dataAttrs } from 'Helpers/Testing';

export const RoadmapDeliverableHeader = ({ resource }) => {
  return (
    <FDStack
      direction={'column'}
      alignItems={'center'}
      width={'100%'}
      maxWidth={600}
      {...resource.withRelationship(
        fr.relationships.guidedHouseholdReviewLayout.name,
        () => ({ spacing: 4 }),
        () => ({ spacing: 2, paddingY: 2 }),
      )}
      {...dataAttrs('roadmap-deliverable-header')}
    >
      {resource.withRelationship(
        fr.relationships.guidedHouseholdReviewLayout.name,
        () => (resource.attr('stepper') ? (
          <Stepper collection={resource.attr('stepper')} />
        ) : null),
        () => null,
      )}
      <FDHeadlineText
        size={'lg'}
        align={'center'}
        value={resource.attr('title')}
        color={'textSecondary'}
      />
      <FDStack direction={'column'} spacing={2}>
        {resource.attr('subtitle')?.map((v) => (
          <FDBodyText key={v} value={v} align={'center'} />
        ))}
      </FDStack>
    </FDStack>
  );
};
